import { createFileRoute } from '@tanstack/react-router'
import { FaceDiagnosticsScreen } from '@/features/face-encoder/diagnostics-screen'

/** Hidden developer route; kiosks link here when their screens are added. */
export const Route = createFileRoute('/face-diagnostics')({
  component: FaceDiagnosticsScreen,
})
